module.exports = __webpack_public_path__ + "img/sf1.ac4e2b74.png";